var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgStorageTank = function SvgStorageTank(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 13h12v9a2 2 0 0 1-2 2h-8a2 2 0 0 1-2-2v-9ZM22 12H10c0-2.21 2.686-4 6-4s6 1.79 6 4Z",
    fill: "currentColor"
  })));
};
export { SvgStorageTank as ReactComponent };
export default "data:image/svg+xml,%3csvg width='32' height='32' viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg'%3e %3cpath d='M10 13H22V22C22 23.1046 21.1046 24 20 24H12C10.8954 24 10 23.1046 10 22V13Z' fill='%234A6067'/%3e %3cpath d='M22 12H16H10C10 9.79086 12.6863 8 16 8C19.3137 8 22 9.79086 22 12Z' fill='%234A6067'/%3e %3c/svg%3e";